import { render, staticRenderFns } from "./PhotographyOverview.vue?vue&type=template&id=6d35eaa4&scoped=true"
import script from "./PhotographyOverview.vue?vue&type=script&lang=ts"
export * from "./PhotographyOverview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d35eaa4",
  null
  
)

export default component.exports